module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Knife1-ed8e673aab646d5deaaed2bcd01148ed.svg";